import { render, staticRenderFns } from "./LangSelect.vue?vue&type=template&id=aaf83abe&scoped=true&"
import script from "./LangSelect.vue?vue&type=script&lang=js&"
export * from "./LangSelect.vue?vue&type=script&lang=js&"
import style0 from "./LangSelect.vue?vue&type=style&index=0&id=aaf83abe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf83abe",
  null
  
)

export default component.exports